/** Compara versiones tipo semver: -1 si `current < latest`, 1 si `current > latest`, 0 si son iguales. */
export function compareVersions(current = '0.0.0', latest = '0.0.0'): number {
  const currentParts = current.split('.').map(part => Number.parseInt(part, 10) || 0);
  const latestParts = latest.split('.').map(part => Number.parseInt(part, 10) || 0);
  const maxLength = Math.max(currentParts.length, latestParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const currentPart = currentParts[index] ?? 0;
    const latestPart = latestParts[index] ?? 0;

    if (currentPart < latestPart) {
      return -1;
    }

    if (currentPart > latestPart) {
      return 1;
    }
  }

  return 0;
}
